import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_GIFT_SET } from './consts/types';

export const updateGiftSet = createTaskAction(
  UPDATE_GIFT_SET,
  undefined,
  task => task.giftSetId,
);
